/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Logo20Component.vue?vue&type=template&id=4faedc25"
import script from "./Logo20Component.vue?vue&type=script&setup=true&lang=ts"
export * from "./Logo20Component.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Logo20Component.vue?vue&type=style&index=0&id=4faedc25&prod&lang=css"
import style1 from "./Logo20Component.vue?vue&type=style&index=1&id=4faedc25&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports